// Angular
import { Injectable } from '@angular/core';
// RxJS
import * as objectPath from 'object-path';
import { BehaviorSubject } from 'rxjs';

// Object-Path
// Service
import { AuthService } from '@app/core/auth';

import { MenuConfigService } from './menu-config.service';

@Injectable()
export class MenuHorizontalService {
  // Public properties
  menuList$ :BehaviorSubject<any> = new BehaviorSubject({});

  /**
   * Service constructor
   *
   * @param menuConfigService: MenuConfigServcie
   */
  constructor(
    private menuConfigService :MenuConfigService,
    private authSvc :AuthService,
  ) {
    this.loadMenu();
  }

  /**
   * Load menu list
   */
  loadMenu() {
    const user :any = this.authSvc.loginUser;
    // get menu list
    const menuItems :any = objectPath.get(
      this.menuConfigService.getMenus(),
      'header.items',
    );
    const menus :any = [];
    menuItems.forEach((mnu) => {
      if (!mnu.adminOnly || user.is_admin) {
        menus.push(mnu);
      }
    });
    this.menuList$.next(menus);
  }
}
